import { render, staticRenderFns } from "./AgregaSigno.vue?vue&type=template&id=6bbbff4f&"
import script from "./AgregaSigno.vue?vue&type=script&lang=js&"
export * from "./AgregaSigno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports